import React from 'react'
import ServiceIcon from '../card-two-side/service-icon'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getPlan } from '../../../services/functions';
import UpgradeBottomSheet from '../../UpgradeBottomSheet/UpgradeBottomSheet';
import { useState } from 'react';

const BtnOperkinds = ({operkind,carId,carTitle}) => {

  const [

    showUpgrade,

    setShowUpgrade,

] = useState(false);

  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  const message = (message,type) => {
    if (type==='warn') {
      toast.warning(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.success(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const plan = getPlan(user);
  // plan => "free"
  // plan => "trial"
  // plan => "pro"
  
  const clickHandler=()=>{

    if (plan === "free" && operkind.id != 1) {

      setShowUpgrade(true);
      // message('با اشتراک رایگان فقط سرویس تعویض روغن قابل تعریف است','warn');
      return;
    }

    navigate(`/add-service-step-3/${carId}/${carTitle}/${operkind.id}/${operkind.title}/${operkind.serviceType}/${operkind.mtbo}/${operkind.unit}`)
    // (res.id,res.title)
  }

  const getPeriodText = (mtbo,unit) => {
    if (unit === "Y") {
      return "دوره تکرار: " + mtbo + " سال" + " (پیش فرض)";
    } else {
      return "دوره تکرار: " + mtbo + " کیلومتر" + " (پیش فرض)";
    }
  };

  return (
    <>
      <button 
        key={operkind.id} 
        type="button" 
        className="btn btn-outline-secondary w-100 text-start p-2"
        onClick={clickHandler}
        style={{ fontSize: "0.9rem" }}
      >
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            <ServiceIcon categoryId={operkind.id} size={20} />
          </div>
          <div className="flex-grow-1 ms-2">
            <div className="d-flex flex-column">
              <span className="fw-bold small">{operkind.title}</span>
              <small className="text-muted">
                {operkind.serviceType === "time" ? "نوع سرویس: زمانی" : "نوع سرویس: کارکردی"}
              </small>
              <small className="text-muted">
                {getPeriodText(operkind.mtbo,operkind.unit)}
              </small>
            </div>
          </div>
        </div>
      </button>
      <UpgradeBottomSheet

        open={showUpgrade}

        title="محدودیت سرویس"

        message="در نسخه رایگان فقط امکان ثبت سرویس تعویض روغن موتور وجود دارد."

        onClose={() =>

            setShowUpgrade(false)

        }

      />  
    </>
  )
}

export default BtnOperkinds